// extracted by mini-css-extract-plugin
export default {"main-nav":"main-navigation_main-nav__waX85"};